var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M445.33 101.33C437.33 101.33 432 96 432 88C432 80 437.33 74.67 445.33 74.67C454.27 74.67 525.73 74.67 534.67 74.67C542.67 74.67 548 80 548 88C548 94.67 541.33 101.33 534.67 101.33C516.8 101.33 454.27 101.33 445.33 101.33Z",
    id: "a3Cd11GYaU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 633.33C12 633.33 6.67 628 6.67 620C6.67 560 6.67 80 6.67 20C6.67 12 12 6.67 20 6.67C80 6.67 560 6.67 620 6.67C628 6.67 633.33 12 633.33 20C633.33 80 633.33 560 633.33 620C633.33 628 628 633.33 620 633.33C500 633.33 80 633.33 20 633.33ZM606.67 606.67L606.67 33.33L33.33 33.33L33.33 606.67L606.67 606.67Z",
    id: "d13I3IkIPq"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.33 558.67C97.33 558.67 92 553.33 92 545.33C92 507.47 92 204.53 92 166.67C92 158.67 97.33 153.33 105.33 153.33C148.27 153.33 491.73 153.33 534.67 153.33C542.67 153.33 548 158.67 548 166.67C548 204.67 548 508.67 548 546.67C548 553.33 541.33 558.67 534.67 558.67C448.8 558.67 148.27 558.67 105.33 558.67ZM521.33 532L521.33 180L118.67 180L118.67 532L521.33 532Z",
    id: "c5Qc7qactf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.67 356C166.67 348 172 342.67 180 342.67C188 342.67 193.33 348 193.33 356C193.33 426.67 250.67 482.67 320 482.67C389.33 482.67 446.67 425.33 446.67 356C446.67 286.67 389.33 229.33 320 229.33C280 229.33 241.33 249.33 217.33 281.33C213.33 286.67 204 288 198.67 284C193.33 280 192 270.67 196 265.33C225.33 225.33 270.67 202.67 320 202.67C405.33 202.67 473.33 272 473.33 356C473.33 441.33 405.33 509.33 320 509.33C234.67 509.33 166.67 440 166.67 356Z",
    id: "j10EyUjjGP"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.67 286.67C194.67 286.67 189.33 281.33 189.33 273.33C189.33 268.8 189.33 232.53 189.33 228C189.33 220 194.67 214.67 202.67 214.67C210.67 214.67 216 220 216 228C216 230.13 216 240.8 216 260C235.2 260 245.87 260 248 260C256 260 261.33 265.33 261.33 273.33C261.33 281.33 256 286.67 248 286.67C238.93 286.67 207.2 286.67 202.67 286.67Z",
    id: "g4Yunwa0XI"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3Cd11GYaU",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a3Cd11GYaU",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d13I3IkIPq",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d13I3IkIPq",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c5Qc7qactf",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c5Qc7qactf",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j10EyUjjGP",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j10EyUjjGP",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g4Yunwa0XI",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g4Yunwa0XI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon6);
export default __webpack_public_path__ + "static/media/info-icon-6.16fda727c6564f95aded2e9b2acac296.svg";
export { ForwardRef as ReactComponent };